import { render, staticRenderFns } from "./BeforeCaution.vue?vue&type=template&id=11517e3a&scoped=true"
import script from "./BeforeCaution.vue?vue&type=script&lang=js"
export * from "./BeforeCaution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11517e3a",
  null
  
)

export default component.exports